import api from '.'

export const packs = {
  getPackTypesForTrial (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/pack-types`, null, success, fail)
  },
  createPackType (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/pack-types`, data, success, fail)
  },
  getPackType (packTypeId, success, fail) {
    api.authenticatedRequest('GET', `/pack-types/${packTypeId}`, null, success, fail)
  },
  updatePackType (packTypeId, data, success, fail) {
    api.authenticatedRequest('PUT', `/pack-types/${packTypeId}`, data, success, fail)
  },
  deletePackType (packTypeId, success, fail) {
    api.authenticatedRequest('DELETE', `/pack-types/${packTypeId}`, null, success, fail)
  },
  getPacksForTrial (trialId, packType, success, fail) {
    const path = packType
      ? `/trials/${trialId}/packs?packType=${encodeURIComponent(packType)}`
      : `/trials/${trialId}/packs`
    api.authenticatedRequest('GET', path, null, success, fail)
  },
  createPack (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/packs`, data, success, fail)
  },
  createBulk (trialId, packTypeId, packs, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/packs`, { packType: packTypeId, packs }, success, fail)
  },
  getPack (packId, success, fail) {
    api.authenticatedRequest('GET', `/packs/${packId}`, null, success, fail)
  },
  updatePack (packId, data, success, fail) {
    api.authenticatedRequest('PUT', `/packs/${packId}`, data, success, fail)
  },
  deletePack (packId, success, fail) {
    api.authenticatedRequest('DELETE', `/packs/${packId}`, null, success, fail)
  },
  deleteBulk (ids, success, fail) {
    api.authenticatedRequest('POST', '/packs/delete', { ids }, success, fail)
  },
  updateBulk (ids, data, success, fail) {
    api.authenticatedRequest('PUT', '/packs/update', { ids, ...data }, success, fail)
  }
}
